/*
  Nice Candy: Versandleiste live aktualisieren.
  Holt nach jeder Warenkorb-Änderung den echten Warenkorbwert (/cart.js) und setzt Text und Balken
  in allen Leisten mit [data-nc-shipbar] (Header und Warenkorbschublade).
  Andere Skripte (z. B. nc-fly-to-cart.js) können window.ncCart.refresh() aufrufen.
  Rutscht der Warenkorb von mindestens der Schwelle auf darunter (Minus, Entfernen), steht ehrlich da,
  wie viel wieder bis zum Gratisversand fehlt ("Schade, jetzt fehlen wieder ...").
*/
(function () {
  if (window.ncCart) return;

  function money(cents) {
    if (window.Shopify && typeof Shopify.formatMoney === 'function') return Shopify.formatMoney(cents);
    return (cents / 100).toFixed(2).replace('.', ',') + ' €';
  }

  var lastTotal = null; // letzter bekannter Warenkorbwert in Cent

  function render(total, animate, cart) {
    var previous = lastTotal;
    lastTotal = total;
    // Nur Abos im Warenkorb (Candy Discovery Club): Versand ist dort immer gratis
    var onlySubs = !!(cart && cart.items && cart.items.length && cart.items.every(function (i) { return i.selling_plan_allocation; }));
    document.querySelectorAll('[data-nc-shipbar]').forEach(function (bar) {
      var threshold = parseInt(bar.dataset.threshold, 10) || 5000;
      var left = threshold - total;
      var lostFree = !onlySubs && previous !== null && previous >= threshold && total > 0 && left > 0;
      var percent = Math.max(0, Math.min(100, Math.round((total / threshold) * 100)));
      var text = bar.querySelector('[data-nc-shipbar-text]');
      var fill = bar.querySelector('[data-nc-shipbar-fill]');
      var html;
      if (onlySubs) {
        html = 'Versand ist bei deinem Club immer gratis <span class="nc-shipbar__truck">🎉</span>';
        percent = 100;
      } else if (total <= 0) {
        html = 'Ab ' + Math.round(threshold / 100) + ' € liefern wir versandkostenfrei <span class="nc-shipbar__truck">🚚</span>';
      } else if (lostFree) {
        html = 'Schade, jetzt fehlen wieder <strong>' + money(left) + '</strong> bis zum kostenlosen Versand <span class="nc-shipbar__truck">🚚</span>';
      } else if (left > 0) {
        html = 'Nur noch <strong>' + money(left) + '</strong> bis zum kostenlosen Versand <span class="nc-shipbar__truck">🚚</span>';
      } else {
        html = 'Yes! Dein Versand ist kostenlos <span class="nc-shipbar__truck">🎉</span>';
      }
      var changed = text && text.innerHTML !== html;
      if (text) text.innerHTML = html;
      if (fill) fill.style.width = percent + '%';
      bar.classList.toggle('is-free', onlySubs || (total > 0 && left <= 0));
      if (animate && changed) {
        bar.classList.remove('is-pop');
        void bar.offsetWidth;
        bar.classList.add('is-pop');
      }
    });
  }

  var pending = null;
  function refresh() {
    if (pending) return pending;
    pending = fetch('/cart.js', { headers: { Accept: 'application/json' }, cache: 'no-store' })
      .then(function (r) { return r.json(); })
      .then(function (cart) {
        render(cart.total_price, true, cart);
        document.dispatchEvent(new CustomEvent('nc:cart', { detail: cart }));
        return cart;
      })
      .catch(function () {})
      .finally(function () { pending = null; });
    return pending;
  }

  window.ncCart = { refresh: refresh, render: render };

  function init() {
    // Startwert aus der Leiste, die der Server gezeichnet hat
    var first = document.querySelector('[data-nc-shipbar][data-total]');
    if (first) lastTotal = parseInt(first.dataset.total, 10) || 0;
    if (typeof subscribe === 'function' && typeof PUB_SUB_EVENTS !== 'undefined') {
      subscribe(PUB_SUB_EVENTS.cartUpdate, function () { refresh(); });
    }
    // Die Schublade baut ihren Inhalt nach Änderungen neu auf, danach Leisten erneut setzen
    document.addEventListener('nc:cart-rerender', refresh);
  }

  if (document.readyState === 'loading') document.addEventListener('DOMContentLoaded', init);
  else init();
})();
